<template>
  <hic-dialog title="新建配置" :visible="visible" @open="openEditor" @close="cancel" :close-on-click-modal="false" width="35.5rem">
    <el-form v-if="value" :model="value" :rules="comRules" ref="editor" label-width="6rem">
      <el-form-item label="子系统编码">
        <el-tag style="width: 100%" hit>
          <b>{{ value.sysCode }}</b>
        </el-tag>
      </el-form-item>
      <el-form-item label="名称" prop="name">
        <el-input class="default-input" size="small" type="text" placeholder="请输入" v-model="value.name" @change="genCode" v-hic-select> </el-input>
      </el-form-item>
      <el-form-item v-if="!value.id" label="编码" prop="code">
        <el-input class="default-input" size="small" type="text" placeholder="请输入" v-model="value.code" v-hic-select> </el-input>
      </el-form-item>
      <el-form-item label="值" prop="value">
        <el-input class="default-input" size="small" type="text" placeholder="请输入" v-model="value.value" v-hic-select> </el-input>
      </el-form-item>
      <el-form-item label="选项" prop="options">
        <el-input class="default-input" size="small" type="textarea" placeholder='{"type":"string" | "number" | "bool" | "text" | "date" | "time" | "dict" , dict: [{code: "", text: ""}]}' :row="2" v-model="value.options" v-hic-select> </el-input>
      </el-form-item>
      <el-form-item label="规则" prop="rule">
        <el-input class="default-input" size="small" type="textarea" placeholder='[{ "required": true, "message": "请设置", "trigger": "blur"}]' :row="2" v-model="value.rule" v-hic-select> </el-input>
      </el-form-item>
      <el-form-item label="排序" prop="seqNo">
        <el-input class="default-input" size="small" type="number" placeholder="请输入数字" v-model.number="value.seqNo" v-hic-select> </el-input>
      </el-form-item>

      <el-form-item label="备注" prop="memo">
        <el-input class="default-input" size="small" type="textarea" placeholder="请输入" :row="2" v-model="value.memo"> </el-input>
      </el-form-item>
    </el-form>
    <template slot="footer">
      <el-button type="info" @click="cancel">关 闭</el-button>
      <el-button type="primary" @click="save()" :disabled="isSaving" :loading="isSaving">确 定</el-button>
    </template>
  </hic-dialog>
</template>
<script>
  import api from "./api.js";
  import { pinyin as py } from "../../../packages/masterdata";
  import { mapGetters } from "sw-hic";
  export default {
    props: {
      value: Object,
      visible: Boolean,
    },
    data() {
      return {
        loading: false,
        comRules: {
          name: [{ required: true, message: "请输入名称", trigger: "blur" }],
          code: [{ required: true, message: "请输入编码", trigger: "blur" }],
          value: [{ required: true, message: "请输入助记码", trigger: "blur" }],
        },
        isSaving: false,
      };
    },
    computed: {
      ...mapGetters(["dict"]),
    },
    methods: {
      openEditor() {},
      save() {
        let _this = this;

        this.$refs.editor.validate((valid) => {
          if (valid) {
            _this.isSaving = true;
            api.Setting.query({ sysCode: _this.value.sysCode, code: _this.value.code })
              .then((res) => {
                if (res.items && res.items.length > 0) {
                  throw new Error("编码已存在，请重新输入！");
                }
                return api.Setting.save(_this.value);
              })
              .then((res) => {
                _this.$message.success("保存成功！");
                _this.$emit("update:visible", false);
                _this.$emit("ok");
              })
              .catch((err) => {
                if (err) {
                  _this.$message.error(err.message || err);
                }
              })
              .finally(() => {
                _this.isSaving = false;
              });
          }
        });
      },
      cancel() {
        this.$emit("update:visible", false);
        this.$emit("cancel");
      },
      genCode(chns) {
        if (!this.value.id) {
          this.$set(this.value, "code", py.chnToPinYin(chns));
        }
      },
    },
  };
</script>
